import React, { useCallback } from "react";
import { Form, Input } from "antd";
import { LocationType, STATUS } from "@/utils/enum";
import { Validator } from "@/utils/validator";
import { removeDropOff, removePickup } from "@/services/loads";

export default function PickupDropoffForm({ formRef, type, onSuccess, loadId, setStatus }) {
  const handleSubmit = useCallback(
    data => {
      setStatus(STATUS.LOADING);

      const apiCaller = type === LocationType.Pickup ? removePickup : removeDropOff;

      apiCaller(loadId, data)
        .then(() => {
          setStatus(STATUS.SUCCESS);
          onSuccess?.();
          formRef?.resetFields();
        })
        .catch(err => {
          console.error(err);
          setStatus(STATUS.ERROR);
        });
    },
    [loadId, type, onSuccess, setStatus],
  );
  return (
    <Form form={formRef} layout="vertical" onFinish={handleSubmit}>
      <Form.Item name="reason" label="Reason" rules={[Validator.required("Select a reason")]}>
        <Input.TextArea rows={4} />
      </Form.Item>
    </Form>
  );
}
